"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
var _a;
import React from "react";
import $ from "jquery";
import _ from "underscore";
import AcertusShipmentApproval from "./acertus_shipment_approval";
import ActivityStreamHelper from "../../helpers/activity_stream";
import Api from "../../api/api";
import toggleHiddenDocument from "../../helpers/toggle_hidden_document";
import ApiService from "../../services/api_service";
import AuditBillingConfirmation from "./audit_billing_confirmation";
import Auth from "../../util/auth";
import { EmbeddedElmComponent } from "./embedded_elm_components";
import * as Pb from "../data/types/Pb";
import Blocker from "../blocker";
import Carrier from "../model/carrier";
import CarrierInvoiceHelper from "../../helpers/carrier_invoice";
import CarrierInvoiceHeader from "../confirm_and_submit/carrier_invoice_header";
import CarrierInvoiceLabelsEditor from "../carrier_invoice/labels_editor";
import CarrierPayableChooser from "../carrier_invoice/carrier_payable_chooser";
import CarrierService from "../../services/carrier_service";
import classNames from "classnames";
import CloseReply from "../close_reply";
import DynamicForm from "./dynamic_form";
import DisablingButton from "../../components/disabling_button";
import DocumentBrowser from "../react_document_browser";
import documentEditor from "../document_editor";
import DocumentInformation from "./document_information";
import DocumentTitle from "../../components/document_title";
import DocumentTypesSetter from "./document_types_setter";
import { nextPageFunctionForRule } from "../../helpers/exceptions_advance_pages";
import ExceptionSender from "../exception_sender";
import CarrierInvoicesStore from "../../stores/carrier_invoices_store";
import EmailHelper from "../../helpers/email_message";
import get from "../data/get";
import Immutable from "immutable";
import IndexerHeader from "./indexer_header";
import InvoiceAbandoner from "../invoice_abandoner";
import fetch from "../../util/fetch";
import Labels from "../labels";
import LoadDetailInformation from "./load_detail_information";
import LoadEmailCreator from "../load_email_creator";
import loadHelper from "../loads";
import LtlConfirmHeader from "./ltl_confirm_header";
import PaymentInformation from "./payment_information";
import PresenceList from "../presence";
import PreviousInvoiceInformation from "./previous_invoice_information";
import ReactCursor from "../../util/react/cursor";
import RemoveFromWaiting from "../remove_from_waiting";
import RulesAndExceptions from "./rules_and_exceptions";
import SelectionList from "../../util/selection_list";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import UnidentifiedDocumentHelper from "../../helpers/unidentified_document";
import s from "underscore.string";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCreator
} from "../grouped_document_browser_model";
import { ReplyProgressBar, IndexerProgress } from "../progress_bars";
import generalFormatter from "../../formatters/general";
import Account from "../../api/account";
import { auditBillingEnabledFor } from "./audit_billing";
import * as popout from "./../popout";
import { BILLING_TYPE, PAYMENT_TYPE } from "./new_exception";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import { CarrierInvoice } from "../domain/carrier_invoice";
import {
  addToIgnoredItems,
  maybePrefetchNextFlowModeItem,
  isInNewFlowMode,
  isInExceptionFlowMode
} from "../flow_mode/flow_mode_service";
import { isAuditMode } from "../index_audit_split_mode";
import { isLtlReconcileEnabled } from "../ltl/reconcile";
import { setPOD } from "../../helpers/documents";
import { escapeRegExp } from "../../util/strings";
import { isImeKey } from "../../util/ime_key";
import loadDocumentRelationshipService from "../../services/load_document_relationship_service";
const selectionList = SelectionList(_.identity);
const throttle = (fn, delay) => {
  const shared = {};
  return (...params) => {
    const last = Date.now();
    shared.last = last;
    setTimeout((_2) => shared.last === last && fn(...params), delay);
  };
};
function isApprovedOrBilled(loadShipment) {
  return loadShipment.approved_at || loadShipment.billed_in_tms;
}
function buildLoadShipmentExceptionResolver(loadShipment) {
  return function(message, exception) {
    return Api.ExceptionEvents.resolve(
      loadShipment.id,
      LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
      message,
      exception
    );
  };
}
function loadCreationExtractedFieldSettings() {
  const fields = Api.Account.currentSettings().load_creation_extracted_fields;
  const extractDefaults = (defaults, field) => field.fields ? __spreadValues(__spreadValues({}, defaults), field.fields.reduce(extractDefaults, {})) : __spreadProps(__spreadValues({}, defaults), { [field.key]: field.default });
  return { fields, defaults: extractDefaults({}, { fields }) };
}
function saveCarrierInvoice(invoice) {
  return Api.CarrierInvoices.update(invoice.id, invoice);
}
function saveWithErrorButton() {
  return /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right", children: /* @__PURE__ */ jsx("span", { className: "load-detail__completion-context", children: "Saving..." }) });
}
function autoApproveAccount() {
  return Api.Account.currentSettings().autoApprove;
}
function indexAuditSplitAccount() {
  return Api.Account.currentSettings().index_audit_split_enabled;
}
function initialDeliveryDocuments(props) {
  var _a2, _b;
  return (((_a2 = props.carrierInvoice) == null ? void 0 : _a2.delivery_documents) || []).concat(
    ((_b = props.load) == null ? void 0 : _b.nidf_delivery_documents) || []
  );
}
function shouldHardUpdateCarrierInvoice(state, props_) {
  const stateInvoiceId = state.carrierInvoice ? state.carrierInvoice.id : null;
  return props_.carrierInvoice && props_.carrierInvoice.id != stateInvoiceId;
}
function possibleProgressBar(props) {
  if (!isLtlReconcileEnabled(props.carrierInvoice)) {
    if (props.location.query.fromReply === "true") {
      return /* @__PURE__ */ jsx(ReplyProgressBar, { stepNumber: 3 });
    } else if (s.startsWith(props.location.pathname, "/index-document-batches")) {
      return /* @__PURE__ */ jsx(
        IndexerProgress,
        {
          stepNumber: 4,
          location: props.location,
          batchId: batchIdFromURL(props)
        }
      );
    }
  }
}
function carrierInvoiceLabels(props) {
  return _.map(props.carrierInvoice.labels, (label) => {
    if (_.isObject(label)) {
      return label.name;
    } else {
      return label;
    }
  });
}
function documentBrowserModel(state) {
  return new GroupedDocumentBrowserModel(
    UngroupedGroupCreator(state.leftSelected.group.documents),
    function() {
      return false;
    },
    void 0
  );
}
function batchIdFromURL(props) {
  const match = props.location.pathname.match(
    /index-document-batches\/(\d+)\//
  );
  if (match) {
    return match[1];
  }
}
function emailId(props) {
  return props.location.query.emailMessageId || props.location.query.emailId;
}
function fromReply(props) {
  return _.filter(
    props.carrierInvoice.emails,
    (email) => !email.completed_at && email.message_type === "reply"
  ).length > 0;
}
function invoiceActivityItems(props) {
  return props.load.activity_items.filter(
    (activityItem) => props.carrierInvoice && (activityItem.owner_type === "CarrierInvoice" && props.carrierInvoice.id === activityItem.owner_id || ["DocumentPage", "TMS::LoadShipment"].includes(
      activityItem.owner_type
    ))
  );
}
function lastIgnoreReason(props) {
  const abandonedItems = invoiceActivityItems(props).filter(
    (item) => {
      var _a2;
      return item.activity_type === "invoice_abandoned" && ((_a2 = item.data) == null ? void 0 : _a2.reason);
    }
  );
  const lastItem = abandonedItems[abandonedItems.length - 1];
  return lastItem && lastItem.data.reason;
}
function possibleOtherInvoices(props, state) {
  if (props.carrierInvoice) {
    const invoices = props.load.carrier_invoices;
    if (invoices.length > 1) {
      return /* @__PURE__ */ jsx(
        PreviousInvoiceInformation,
        {
          location: props.location,
          carrierInvoices: props.load.carrier_invoices,
          currentInvoice: props.carrierInvoice,
          v3ReskinEnabled: state.v3ReskinEnabled
        }
      );
    }
  }
}
function advanceableTextClicked(props, text) {
  const hasText = (p) => _.some(p.lines, (l) => l.chars.match(escapeRegExp(text)));
  props.model.selectNextPageMatchingRule(hasText);
}
function exceptionClicked(props, rule) {
  const nextPageFunction = nextPageFunctionForRule(rule);
  if (nextPageFunction) {
    props.model.selectNextPageMatchingRule(nextPageFunction);
  }
}
function possibleBillRulesAndExceptions(props, state) {
  const tmsLoadShipments = props.load && props.load.load && props.load.load.tms_load_shipments;
  if (showExceptions(props) && tmsLoadShipments) {
    const tmsShipments = get.tmsShipments(props.load.load);
    const shipmentsById = _.object(
      tmsShipments.map((x) => [x.id, x])
    );
    const sortable = tmsLoadShipments.map((loadShipment) => {
      const isApprovedOrBilledOrder = isApprovedOrBilled(loadShipment) ? 1 : -1;
      const shipment = shipmentsById[loadShipment.tms_shipment_id];
      const externalId = shipment && shipment.external_id;
      return {
        item: loadShipment,
        sortScore: [
          isApprovedOrBilledOrder,
          // always put approved/billed to bottom
          externalId,
          // then sort by external id
          loadShipment.id
          // finally, sort by id for tie-breaking
        ]
      };
    });
    const sorted = _.sortBy(sortable, "sortScore").map((s2) => s2.item);
    const loadShipmentComponents = sorted.map((loadShipment) => {
      return /* @__PURE__ */ jsx(
        RulesAndExceptions,
        {
          readOnly: invoiceIsReadOnly(props),
          loadShipment,
          carrierInvoice: props.carrierInvoice,
          load: props.load,
          exceptionCreator: buildBillingExceptionCreator(props, loadShipment),
          exceptionResolver: buildLoadShipmentExceptionResolver(loadShipment),
          exceptionEvents: loadShipment.exception_events,
          exceptionClicked: (rule) => exceptionClicked(props, rule),
          v3ReskinEnabled: state.v3ReskinEnabled
        },
        loadShipment.id
      );
    });
    if (props.v3ReskinEnabled) {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-xs)"
          },
          children: [
            /* @__PURE__ */ jsx("h2", { children: "Exceptions" }),
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("h4", { children: "Customer" }),
              loadShipmentComponents
            ] })
          ]
        }
      );
    } else {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "indexer-header__subject", children: "Customer Exceptions" }),
        loadShipmentComponents
      ] });
    }
  }
}
function showExceptions(props) {
  return !!props.carrierInvoice;
}
function possibleCustomerInstructions(props) {
  const customer = props.load.load.customer;
  const instructionsList = customer ? customer.instructions_list : null;
  const settings = Api.Account.currentSettings() || {};
  const billingRequirementsPopoutEnabled = settings["use_billing_reqs_popout"];
  if (!billingRequirementsPopoutEnabled && instructionsList && instructionsList.length > 0) {
    const instructionsListItems = instructionsList.map(
      (instructions, index) => {
        return /* @__PURE__ */ jsx("p", { children: instructions }, index);
      }
    );
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Customer Instructions" }),
      /* @__PURE__ */ jsx("div", { children: instructionsListItems })
    ] });
  } else {
    return;
  }
}
function buildPaymentExceptionCreator(props) {
  const carrierInvoice = props.carrierInvoice;
  const tmsLoadShipments = loadShipments(props);
  return function(message, ignore, types) {
    const promises = [];
    if (types.includes(BILLING_TYPE)) {
      tmsLoadShipments.forEach((loadShipment) => {
        promises.push(
          Api.ExceptionEvents.create(
            loadShipment.id,
            LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
            message
          )
        );
      });
    }
    if (types.includes(PAYMENT_TYPE)) {
      promises.push(
        Api.ExceptionEvents.create(
          carrierInvoice.id,
          CARRIER_INVOICE_MODEL_OBJECT_TYPE,
          message
        )
      );
    }
    return Promise.all(promises);
  };
}
function buildBillingExceptionCreator(props, loadShipment) {
  const carrierInvoice = props.carrierInvoice;
  return function(message, ignore, types) {
    const promises = [];
    if (types.includes(BILLING_TYPE)) {
      promises.push(
        Api.ExceptionEvents.create(
          loadShipment.id,
          LOAD_SHIPMENT_MODEL_OBJECT_TYPE,
          message
        )
      );
    }
    if (types.includes(PAYMENT_TYPE)) {
      promises.push(
        Api.ExceptionEvents.create(
          carrierInvoice.id,
          CARRIER_INVOICE_MODEL_OBJECT_TYPE,
          message
        )
      );
    }
    return Promise.all(promises);
  };
}
function approvedCarrierInvoice(props) {
  const carrierInvoice = props.carrierInvoice;
  return carrierInvoice && new CarrierInvoice(carrierInvoice, props.load).isApproved();
}
function approvedWaitingInvoice(props) {
  return approvedCarrierInvoice(props) && props.carrierInvoice.active_exceptioned_item;
}
function possibleIgnoreReasonMessage(props) {
  if (props.carrierInvoice && props.carrierInvoice.state === "abandoned") {
    const reason = lastIgnoreReason(props);
    return /* @__PURE__ */ jsxs("div", { className: "alert-box warning", children: [
      "Ignore reason: ",
      reason || "No Ignore Reason Provided"
    ] });
  }
}
function hasMore(props) {
  return props.location.query && props.location.query.hasMore === "true";
}
function addShipmentAssignmentListener(state, name, fn) {
  state.shipmentAssignmentListeners[name] = fn;
}
function possibleAcertusShipmentApproval(props, state) {
  const settings = Api.Account.currentSettings() || {};
  if (settings.feature_enable_per_shipment_approval) {
    const hasAssignedPod = (shipment) => {
      return state.shipments[shipment.id] && state.shipments[shipment.id].meets_pod_requirements;
    };
    return /* @__PURE__ */ jsx(
      AcertusShipmentApproval,
      {
        hasAssignedPod,
        onUpdate: () => updateExceptions(state),
        addShipmentAssignmentListener: (name, fn) => addShipmentAssignmentListener(state, name, fn),
        load: props.load.load,
        carrierInvoice: props.carrierInvoice,
        shipmentUpdate: state.shipmentUpdate
      },
      props.carrierInvoice.id
    );
  } else {
    return null;
  }
}
function updateExceptions(state) {
  saveCarrierInvoice(state.carrierInvoice);
}
function creatingLoad(props) {
  const load = props.load.load;
  return !load.sent_to_tms_at && load.source_system === "hubtran";
}
function canAbandonInvoice(props) {
  return props.carrierInvoice && props.carrierInvoice.state !== "abandoned" && props.carrierInvoice.state !== "approved";
}
function invoiceIsReadOnly(props) {
  return props.carrierInvoice && (props.carrierInvoice.state === "approved" || props.carrierInvoice.state === "abandoned");
}
function auditBillingInvoiceIsReadOnly(props) {
  return props.carrierInvoice && props.carrierInvoice.state === "partial_approved";
}
function showNoteFieldByDefault(props) {
  return !_.isEmpty(props.carrierInvoice.ignored_rules);
}
function additionalBrowserComponents(props) {
  if (props.carrierInvoice) {
    return _.compact([
      possibleMessageBrowserComponent(props),
      activityBrowserComponent(props)
    ]);
  } else {
    return [];
  }
}
function activityBrowserComponent(props) {
  return {
    label: "Activity",
    component: ActivityStreamHelper.invoiceActivity(
      invoiceActivityItems(props)
    )
  };
}
function documentFromEmail(props, emailMessage) {
  const model = props.model;
  const groupId = model.selectedDocument.document_group_id;
  const emailId2 = emailMessage.id;
  return documentEditor.documentFromEmail(emailId2, groupId);
}
function possibleMessageBrowserComponent(props) {
  if (props.carrierInvoice.emails.length > 0) {
    const documentCreator = props.carrierInvoice.state === "approved" ? null : (emailMessage) => documentFromEmail(props, emailMessage);
    return {
      label: "Messages",
      component: EmailHelper.emailMessages(
        props.carrierInvoice.emails,
        documentCreator
      )
    };
  }
}
function cleanedAmount(props, invoice, field) {
  var _a2;
  const amount = invoice[field];
  if (_.isEmpty(amount)) {
    return amount;
  }
  const cleaned = (_a2 = generalFormatter.cleanAmount(amount)) != null ? _a2 : "0.00";
  props.carrierInvoice[field] = cleaned;
  return cleaned;
}
function sourceInvoiceAmount(props, invoice) {
  return cleanedAmount(props, invoice, "source_invoice_amount");
}
function invoiceAmountToPay(props, invoice) {
  return cleanedAmount(props, invoice, "amount_to_pay");
}
function clearTimer(state) {
  if (state.pendingTimeout) {
    window.clearTimeout(state.pendingTimeout);
  }
}
function hasDocuments(props) {
  return props.model.allDocuments().length > 0;
}
function isSavableFromPage(props) {
  return savableInvoice(props) && !autoApproveAccount();
}
function areLoadShipmentsAreApprovable(props) {
  return loadShipments(props).every((ls) => ls.approvable);
}
function loadShipments(props) {
  if (props.load && props.load.load && props.load.load.tms_load_shipments) {
    return props.load.load.tms_load_shipments;
  } else {
    return [];
  }
}
function savableInvoice(props) {
  return !invoiceIsReadOnly(props) && isApprovable(props);
}
function forwardInvoiceDocs(props) {
  return Api.Account.current()["triumphpay_id"] && props.carrierInvoice.emails.length > 0;
}
function isApprovable(props) {
  var _a2;
  if (auditBillingEnabledFor(props.carrierInvoice, (_a2 = props.load) == null ? void 0 : _a2.load)) {
    return props.carrierInvoice.approvable;
  } else {
    return loadHelper.isApprovable(props.carrierInvoice);
  }
}
function isSaving(state) {
  return state.immutable.get("isSaving") || state.savingDocuments;
}
function carrier(props) {
  return props.carrier;
}
function initialDocumentBrowserComponent(props) {
  return props.location.query.activeDocumentTab;
}
function possibleRulesAndExceptions(props, state) {
  if (showExceptions(props)) {
    return /* @__PURE__ */ jsx(
      RulesAndExceptions,
      {
        readOnly: invoiceIsReadOnly(props) || auditBillingInvoiceIsReadOnly(props),
        carrierInvoice: props.carrierInvoice,
        load: props.load,
        exceptionCreator: buildPaymentExceptionCreator(props),
        exceptionResolver: (message, exception) => resolveException(props, message, exception),
        exceptionEvents: props.carrierInvoice.exception_events,
        exceptionClicked: (rule) => exceptionClicked(props, rule),
        v3ReskinEnabled: state.v3ReskinEnabled
      }
    );
  }
}
function resolveException(props, message, exception) {
  return Api.ExceptionEvents.resolve(
    props.carrierInvoice.id,
    CARRIER_INVOICE_MODEL_OBJECT_TYPE,
    message,
    exception
  );
}
function saveAddress(props, address) {
  return CarrierService.createAddress(carrier(props), "direct", address).then(
    () => saveCarrierInvoice(props.carrierInvoice)
  );
}
function savePaymentStrategy(props, paymentStrategy, paymentDetails) {
  return CarrierService.createAddress(
    carrier(props),
    paymentStrategy,
    paymentDetails
  ).then(() => saveCarrierInvoice(props.carrierInvoice));
}
function joinText(props) {
  if (saveAndSaveAndApprovedButtonsDisplayed(props)) {
    return "or";
  }
}
function isApprovableFromPage(props) {
  var _a2;
  const approvalIsAllowed = Auth._currentUser.approver || !indexAuditSplitAccount() && autoApproveAccount();
  const approvable = savableInvoice(props) && approvalIsAllowed;
  if (auditBillingEnabledFor(props.carrierInvoice, (_a2 = props.load) == null ? void 0 : _a2.load)) {
    return approvable && areLoadShipmentsAreApprovable(props);
  } else {
    return approvable;
  }
}
function saveAndSaveAndApprovedButtonsDisplayed(props) {
  return isApprovableFromPage(props) && !autoApproveAccount();
}
function possibleCloseReplyButton(props) {
  if (approvedCarrierInvoice(props) && fromReply(props) && emailId(props)) {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        CloseReply,
        {
          emailId: emailId(props),
          onComplete: () => loadComplete(props)
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "load-detail__completion-context", children: props.completionContext })
    ] });
  }
}
function possibleStuckInWaitingMessage(props) {
  if (approvedWaitingInvoice(props)) {
    return /* @__PURE__ */ jsx(
      RemoveFromWaiting,
      {
        itemId: props.carrierInvoice.active_exceptioned_item.id,
        onComplete: () => loadComplete(props)
      }
    );
  }
}
function loadComplete(props) {
  ToDashboardWithFilters(props.location);
}
function skipInvoice(props) {
  addToIgnoredItems("load_state_ids", props.load.id);
  ToDashboardWithFilters(props.location);
}
function skipExceptionItem(props) {
  addToIgnoredItems("load_state_ids", props.load.id);
  ToDashboardWithFilters(props.location);
}
function possibleReturnToDashboardOrNextGroupButton(props, state) {
  const isAbandoned = loadHelper.isAbandoned(props.carrierInvoice);
  if (isAbandoned) {
    return /* @__PURE__ */ jsxs(
      DisablingButton,
      {
        disabled: state.isUnIgnoring,
        className: "button--progress load-detail__return-to-dashboard-button",
        onClick: () => loadComplete(props),
        disabledText: "Un-Ignoring...",
        children: [
          " ",
          hasMore(props) ? "Go To Next Group" : "Return To Dashboard"
        ]
      }
    );
  }
}
const POPOUT_LISTENER_NAME = "load_detail";
class LoadDetail extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "mounted", false);
    __publicField(this, "selectedPageAtFirstRender", (_a = this.props.model) == null ? void 0 : _a.selectedPage);
    __publicField(this, "updateFactoringCompany", (carrierInvoice) => {
      const self = this;
      Api.FactoringCompanies.byCarrierInvoiceId(carrierInvoice.id).then(
        function(data) {
          if (data && data.factoring_companies) {
            const factoringCompany = data.factoring_companies[0];
            self.setState({ factoringCompany });
          }
        }
      );
    });
    __publicField(this, "resetViewAfterAddingDocument", (newProps) => {
      if (UnidentifiedDocumentHelper.setPageFromUnidentifiedDocument(newProps.model)) {
        this.editDocumentType();
        this.setState(
          { selectedComponent: "Documents" },
          () => this.setState({ selectedComponent: null })
        );
      }
    });
    __publicField(this, "updateShipments", (shipmentsList) => {
      const shipments = shipmentsList.reduce((acc, s2) => {
        acc[s2.id] = s2;
        return acc;
      }, {});
      this.setState({ shipments });
    });
    __publicField(this, "onPopoutToggle", () => {
      if (this.mounted) {
        this.forceUpdate();
      }
    });
    __publicField(this, "setMissingRequiredFields", (fields) => {
      this.setState({ missingRequiredFields: fields });
    });
    __publicField(this, "editLabels", () => {
      this.setState({
        immutable: this.state.immutable.set("isEditingLabels", true).set(
          "selectedLabels",
          selectionList.newList(carrierInvoiceLabels(this.props))
        )
      });
    });
    __publicField(this, "cancelEditingLabels", () => {
      this.setState({
        immutable: this.state.immutable.set("isEditingLabels", false)
      });
    });
    __publicField(this, "saveLabels", () => {
      const newState = this.state.immutable.set("isEditingLabels", false);
      const carrierInvoice = this.state.carrierInvoice;
      carrierInvoice.labels = this.state.immutable.get("selectedLabels").toJS();
      this.setState({ immutable: newState, carrierInvoice });
      this.saveInvoice();
    });
    __publicField(this, "leftModuleOrDocumentBrowser", (invoice) => {
      if (this.state.browserExpanded) return null;
      if (this.state.leftSelected) {
        const group = this.state.leftSelected.group;
        const page = this.state.leftSelected.page;
        const documents = this.showDocumentBrowser(page, group);
        return /* @__PURE__ */ jsx("div", { className: "xlarge-4 small-5 column load-detail__left-side-document-browser-area", children: /* @__PURE__ */ jsx("div", { className: "load-detail__left-side-document-browser", children: documents }) });
      }
      return this.leftModule(invoice);
    });
    __publicField(this, "showDocumentBrowser", (selectedPage, group) => {
      const model = documentBrowserModel(this.state);
      model.selectedPage = selectedPage;
      model.groups = [group];
      return /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          model,
          closeBrowser: this.closeLeftSideDocumentBrowser,
          collapseSingleGroup: false,
          allowsEditingPodStatus: false,
          canEditDocumentType: false,
          carrier: carrier(this.props),
          shipments: this.state.shipments,
          documentLoadRelationships: this.props.documentLoadRelationships
        }
      );
    });
    __publicField(this, "closeLeftSideDocumentBrowser", () => {
      this.setState({ leftSelected: null });
    });
    __publicField(this, "auditBillingEnabled", () => {
      var _a2;
      return auditBillingEnabledFor(this.props.carrierInvoice, (_a2 = this.props.load) == null ? void 0 : _a2.load);
    });
    __publicField(this, "leftModule", (invoice) => {
      var _a2, _b;
      let actionAreaClassName = "load-detail__action-area";
      if (this.auditBillingEnabled()) {
        actionAreaClassName = "load-detail__audit-billing-action-area";
      }
      const moduleClassName = "small-5 xlarge-4 column load-detail__container " + actionAreaClassName;
      if (this.state.editingDocumentType) {
        return /* @__PURE__ */ jsx("div", { className: moduleClassName, children: /* @__PURE__ */ jsx(
          DocumentTypesSetter,
          {
            model: this.props.model,
            onUpdate: this.typeUpdated,
            onComplete: this.typeComplete,
            stayOnPageAfterSetting: true,
            documentIndexerService: this.props.documentIndexerService
          }
        ) });
      }
      if (this.props.carrierInvoice) {
        var standardHeader = /* @__PURE__ */ jsx(
          CarrierInvoiceHeader,
          {
            carrierInvoice: this.props.carrierInvoice,
            batchId: batchIdFromURL(this.props),
            load: this.props.load
          }
        );
        var autoConfirmedHeaderFlags = {
          componentFlags: {
            type: Pb.EmbeddedComponentsFlags_ComponentFlagsType.AutoConfirmedLoadHeader,
            auto_confirmed_load_header: {
              load_id: this.props.load.load.load_id,
              carrier_invoice_status: (_b = (_a2 = this.props.carrierInvoice) == null ? void 0 : _a2.status) != null ? _b : null
            }
          }
        };
        var autoConfirmedHeader = /* @__PURE__ */ jsx(
          EmbeddedElmComponent,
          {
            componentFlags: autoConfirmedHeaderFlags
          },
          `autoConfirmedHeader:${JSON.stringify(autoConfirmedHeaderFlags)}`
        );
        var header = this.props.load.load.load_is_auto_confirmed ? autoConfirmedHeader : standardHeader;
      } else {
        var header = null;
      }
      return /* @__PURE__ */ jsxs("div", { className: moduleClassName, children: [
        header,
        possibleStuckInWaitingMessage(this.props),
        possibleIgnoreReasonMessage(this.props),
        possibleCloseReplyButton(this.props),
        possibleOtherInvoices(this.props, this.state),
        this.possibleExceptionSender(invoice),
        this.auditBillingEnabled() && possibleBillRulesAndExceptions(this.props, this.state),
        possibleRulesAndExceptions(this.props, this.state),
        possibleCustomerInstructions(this.props),
        this.possibleIndexing(invoice)
      ] });
    });
    __publicField(this, "textToHighlightChanged", (text) => {
      popout.setHoveredText(text);
      this.setState({ textToHighlight: text });
    });
    __publicField(this, "exceptionsV3Reskin", () => {
      if (showExceptions(this.props)) {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-xs)"
            },
            children: [
              this.auditBillingEnabled() && possibleBillRulesAndExceptions(this.props, this.state),
              possibleRulesAndExceptions(this.props, this.state),
              this.internalNoteV3Reskin()
            ]
          }
        );
      }
    });
    __publicField(this, "typeUpdated", (document) => {
      this.forceUpdate();
      this.removeDeliveryDocumentSelectionsForDocument(document);
      Api.Documents.save(document);
    });
    __publicField(this, "typeComplete", () => {
      if (this.props.carrierInvoice) {
        Api.CarrierInvoices.runRules(this.props.carrierInvoice.id);
      }
      this.setState({ editingDocumentType: false });
    });
    __publicField(this, "editDocumentType", () => {
      this.setState({ editingDocumentType: true });
    });
    __publicField(this, "possibleExceptionSender", (invoice) => {
      const settings = Api.Account.currentSettings() || {};
      if (this.state.sendingException && invoice.active_exceptioned_item) {
        const exceptionedItemId = invoice.active_exceptioned_item.id;
        const templateVariables = Api.Account.current().payables_template_variables;
        const defaultEmail = LoadEmailCreator(
          this.props.load,
          this.props.carrierInvoice,
          Auth._currentUser,
          settings.custom_exception_email_subject_template,
          settings.custom_exception_email_body_template,
          templateVariables,
          carrier(this.props)
        ).initialEmail();
        let contacts;
        if (settings.only_show_load_contacts_for_exception_emails) {
          contacts = [];
        } else {
          contacts = carrier(this.props).contacts;
        }
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          ExceptionSender,
          {
            documents: this.props.model.allDocuments(),
            onComplete: () => loadComplete(this.props),
            carrierInvoice: this.props.carrierInvoice,
            carrier: carrier(this.props),
            factoringCompany: this.state.factoringCompany,
            defaultEmail,
            possibleLoad: this.props.load,
            parent: this.props.email || _.findWhere(this.props.carrierInvoice.emails || [], {
              id: parseInt(this.props.location.query.emailMessageId)
            }),
            contacts,
            hasMore: hasMore(this.props),
            canCancel: true,
            cancel: this.cancelException,
            exceptionedItemId,
            multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
            customEmailTemplates: settings.custom_exception_email_templates,
            templateVariables
          }
        ) });
      }
    });
    __publicField(this, "cancelException", () => {
      this.setState({ sendingException: false });
    });
    __publicField(this, "possibleIndexing", (invoice) => {
      if (this.props.carrierInvoice && !this.state.sendingException) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("hr", {}),
          this.possibleSaveButtons(),
          this.possibleAuditBillingOrSaveWithErrorsButton(),
          /* @__PURE__ */ jsxs("span", { className: "load-detail__right-buttons-wrapper", children: [
            this.possibleUnIgnoreButton(),
            possibleReturnToDashboardOrNextGroupButton(this.props, this.state)
          ] }),
          this.possibleDocumentInformation(invoice),
          this.possiblePaymentInformation(),
          this.possibleLoadCreationFields(),
          possibleAcertusShipmentApproval(this.props, this.state),
          this.carrierPayable(),
          popout.isDocumentViewerOpen() ? /* @__PURE__ */ jsx("div", {}) : this.possibleLoadDetailInformation(),
          this.labels()
        ] });
      } else if (!this.state.sendingException) {
        return /* @__PURE__ */ jsx("div", { children: popout.isDocumentViewerOpen() ? /* @__PURE__ */ jsx("div", {}) : this.possibleLoadDetailInformation() });
      }
    });
    __publicField(this, "possibleLoadCreationFields", () => {
      const { fields, defaults } = loadCreationExtractedFieldSettings();
      const load = this.props.load.load || {};
      const initial = this.initialCreationFields({ fields, defaults, load });
      if (creatingLoad(this.props)) {
        return /* @__PURE__ */ jsx(
          DynamicForm,
          {
            fields,
            onFormUpdate: throttle(this.updateLoad, 1e3),
            form: initial,
            customer: load.customer
          }
        );
      }
    });
    __publicField(this, "initialCreationFields", ({ fields, defaults, load }) => {
      const keys = this.extractKeysFrom({ fields }, ["id"]);
      return keys.reduce((obj, key) => {
        obj[key] = load[key] || load.data[key] || defaults[key];
        return obj;
      }, {});
    });
    __publicField(this, "extractKeysFrom", (field, keys = []) => {
      if (field.fields) {
        return keys.concat(
          field.fields.reduce(
            (keys2, field2) => this.extractKeysFrom(field2, keys2),
            []
          )
        );
      } else {
        switch (field.type) {
          case "lookupAddress":
          case "labeledAddress":
          case "address":
            const key = field.key;
            return keys.concat([
              `${key}_name`,
              `${key}_address_line_1`,
              `${key}_address_line_2`,
              `${key}_city`,
              `${key}_state`,
              `${key}_postal_code`
            ]);
          default:
            return keys.concat([field.key]);
        }
      }
    });
    __publicField(this, "updateLoad", (hasError, load, setErrorMessages) => {
      var load_details = this;
      if (hasError) {
        load_details.setMissingRequiredFields(true);
      } else {
        load_details.setMissingRequiredFields(false);
      }
      return ApiService.addErrorHandler(
        fetch("/api/tms/loads/" + load.id, {
          method: "PUT",
          data: { load: __spreadProps(__spreadValues({}, load), { data: void 0 }) }
        }).then(function(response) {
          if (response.errors) {
            load_details.setMissingRequiredFields(true);
            setErrorMessages(response.errors);
          } else {
            setErrorMessages({});
          }
        }),
        null,
        { caller: "LoadDetail.updateLoad" }
      );
    });
    __publicField(this, "possibleLoadDetailInformation", () => {
      if (!creatingLoad(this.props)) {
        return /* @__PURE__ */ jsx(
          LoadDetailInformation,
          {
            onTextToHighlightChanged: this.textToHighlightChanged,
            advanceableTextClicked: (text) => advanceableTextClicked(this.props, text),
            model: this.props.model,
            load: this.props.load,
            invoice: this.props.carrierInvoice
          }
        );
      }
    });
    __publicField(this, "header", () => {
      var _a2, _b;
      let headerSource = this.props.email;
      if (!this.props.email) {
        headerSource = {
          subject: "Load: " + this.props.load.load.load_id,
          sender_address: "",
          created_at: this.props.load.created_at
        };
      }
      const displayReference = Account.currentSettings().display_load_reference_as_title;
      const tmsLoad = (_a2 = this.props.load) == null ? void 0 : _a2.load;
      const isLtlAuditCustomer = Api.Account.currentSettings().ltl_reconcile_enabled && Api.Account.currentSettings().index_audit_split_enabled;
      const className = this.state.v3ReskinEnabled ? "" : "document-indexer__header" + (isLtlAuditCustomer ? " document-indexer__header--ltl" : "");
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className, children: /* @__PURE__ */ jsx(
          IndexerHeader,
          {
            email: headerSource,
            actions: this.actions(),
            load: tmsLoad,
            invoice: this.props.carrierInvoice,
            displayReference,
            isLtlAuditCustomer,
            v3ReskinEnabled: this.state.v3ReskinEnabled,
            carrierInvoices: (_b = this.props.load) == null ? void 0 : _b.carrier_invoices
          }
        ) }),
        isLtlReconcileEnabled(this.props.carrierInvoice) && !this.state.v3ReskinEnabled && /* @__PURE__ */ jsx(
          LtlConfirmHeader,
          {
            invoice: this.props.carrierInvoice,
            load: tmsLoad,
            location: this.props.location
          }
        )
      ] });
    });
    __publicField(this, "v3ReskinContents", () => {
      const divider = /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            width: "100%",
            height: "1px",
            background: "var(--color-navy-400)"
          }
        }
      );
      const sections = [
        this.header(),
        possibleOtherInvoices(this.props, this.state),
        this.exceptionsV3Reskin(),
        this.possibleDocumentInformation()
      ].filter(Boolean).map((section, i) => /* @__PURE__ */ jsx("div", { style: { margin: "var(--space-s)" }, children: section }, `section-${i}`)).flatMap(
        (section, i) => i == 0 ? [section] : [React.cloneElement(divider, { key: `divider-${i}` }), section]
      );
      return /* @__PURE__ */ jsx("div", { className: "enable_shared-ui-v3", style: { marginBottom: "32px" }, children: /* @__PURE__ */ jsx("div", { className: "v3__theme audit_v3_reskin audit_v3_reskin__activate_container", children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", background: "#FDFDFD" }, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "v3__type__small-body",
            style: {
              display: "flex",
              flexDirection: "column",
              flex: 1
            },
            children: sections
          }
        ),
        /* @__PURE__ */ jsx("div", { style: { flex: 1 }, children: this.documentBrowserOrMessage() })
      ] }) }) });
    });
    __publicField(this, "actions", () => {
      const actions = [];
      const location = this.props.location;
      if (canAbandonInvoice(this.props)) {
        actions.push(["Ignore Invoice", this.startAbandoningInvoice]);
      }
      if (invoiceIsReadOnly(this.props)) {
        actions.push(["I'm Done", () => loadComplete(this.props)]);
      }
      if (Api.Account.indexAuditSplitEnabled() && isAuditMode(location) && isInNewFlowMode(location.query.onDone)) {
        if (this.props.v3ReskinEnabled) {
          actions.push(["Next", () => skipInvoice(this.props)]);
        } else {
          actions.push([
            "Next Item",
            () => skipInvoice(this.props),
            "next-control"
          ]);
        }
      }
      if (Api.Account.indexAuditSplitEnabled() && isInExceptionFlowMode(location)) {
        if (this.props.v3ReskinEnabled) {
          actions.push(["Next", () => skipExceptionItem(this.props)]);
        } else {
          actions.push([
            "Next Item",
            () => skipExceptionItem(this.props),
            "next-control"
          ]);
        }
      }
      return actions;
    });
    __publicField(this, "possibleModalView", () => {
      var _a2, _b;
      if (this.state.abandoningInvoice) {
        const loadDocumentBatchId = (_b = (_a2 = this.props.load) == null ? void 0 : _a2.document_batch_ids) == null ? void 0 : _b[0];
        return /* @__PURE__ */ jsx(
          InvoiceAbandoner,
          {
            abandon: this.abandonInvoice,
            documentBatchId: batchIdFromURL(this.props) || loadDocumentBatchId,
            isPaymentsNetworkSubmission: !!this.props.carrierInvoice.is_payments_network_submission,
            onCancel: () => this.setState({ abandoningInvoice: false }),
            markAsDuplicate: this.markInvoiceAsDuplicate
          }
        );
      }
    });
    __publicField(this, "abandonInvoice", (reason) => {
      return Api.CarrierInvoices.abandon(this.props.carrierInvoice.id, reason).then(() => this.setState({ abandoningInvoice: false })).catch(console.error);
    });
    __publicField(this, "startAbandoningInvoice", () => {
      this.setState({ abandoningInvoice: true });
    });
    __publicField(this, "markInvoiceAsDuplicate", (documentBatchId, carrierInvoiceId) => {
      return Api.DocumentBatches.ignoreAsDuplicate(
        documentBatchId,
        carrierInvoiceId
      ).then(() => this.setState({ abandoningInvoice: false })).catch(console.error);
    });
    __publicField(this, "possibleDocumentInformation", (args = {}) => {
      if (hasDocuments(this.props) && this.props.carrierInvoice) {
        return /* @__PURE__ */ jsx(
          DocumentInformation,
          {
            model: this.props.model,
            keyPressNotifier: this.keyPressNotifier,
            factoringAssignment: this.props.model.factoringAssignment(),
            updatePaymentField: this.updatePaymentField,
            source_invoice_number: this.props.carrierInvoice.source_invoice_number,
            source_invoice_date: this.props.carrierInvoice.source_invoice_date,
            source_invoice_amount: sourceInvoiceAmount(
              this.props,
              this.props.carrierInvoice
            ),
            cleanedSourceInvoiceNumber: this.state.cleanedSourceInvoiceNumber,
            noteFieldChanged: this.noteFieldChanged,
            invoiceFieldChanged: this.invoiceFieldChanged,
            invoiceFieldsChanged: this.invoiceFieldsChanged,
            invoiceChangeComplete: () => {
            },
            toggleDocumentData: this.toggleDocumentData,
            document: this.props.model.selectedDocument,
            readOnly: invoiceIsReadOnly(this.props) || auditBillingInvoiceIsReadOnly(this.props),
            load: this.props.load,
            quickpay: this.state.carrierInvoice.quickpay,
            carrierInvoice: this.state.carrierInvoice,
            carrier: CarrierService.getCarrierOrUnknown(
              this.props.carrierInvoice.carrier_id
            ),
            showNoteFieldByDefault: showNoteFieldByDefault(this.props),
            currentNote: this.state.note,
            invoice_disposition: this.state.carrierInvoice.disposition,
            v3ReskinEnabled: this.state.v3ReskinEnabled,
            showInternalNoteV3Reskin: args.showInternalNoteV3Reskin
          }
        );
      }
    });
    __publicField(this, "internalNoteV3Reskin", () => {
      return this.possibleDocumentInformation({ showInternalNoteV3Reskin: true });
    });
    __publicField(this, "labels", () => {
      return /* @__PURE__ */ jsxs("div", { className: "load-detail__labels-container", children: [
        /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header load-detail__section-header__labels", children: "Labels" }),
        /* @__PURE__ */ jsx("div", { style: { marginTop: "10px" }, children: this.labelsOrEditor() })
      ] });
    });
    __publicField(this, "labelsOrEditor", () => {
      if (!this.state.immutable.get("isEditingLabels")) {
        if (this.props.carrierInvoice) {
          const labels = _.union(
            carrier(this.props).labels,
            this.props.carrierInvoice.labels
          );
          return /* @__PURE__ */ jsx(Labels, { labels, onEdit: this.editLabels });
        }
        return /* @__PURE__ */ jsx(Labels, { labels: carrier(this.props).labels });
      }
      const cursor = ReactCursor(this, ["immutable", "selectedLabels"]);
      return /* @__PURE__ */ jsx(
        CarrierInvoiceLabelsEditor,
        {
          labels: Carrier.LABELS(),
          carrierLabels: carrier(this.props).labels,
          selectedLabels: cursor,
          onCancel: this.cancelEditingLabels,
          onSave: this.saveLabels
        }
      );
    });
    __publicField(this, "openThumbnailLeft", (group, page) => {
      this.setState({ leftSelected: { group, page } });
    });
    __publicField(this, "documentBrowserOrMessage", () => {
      const isColumnView = !(this.state.browserExpanded || this.state.v3ReskinEnabled);
      const classes = classNames({
        "x-large-6": isColumnView,
        "small-5": isColumnView,
        "small-10": !isColumnView,
        column: true,
        "document-indexer__document-side": true
      });
      return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          model: this.props.model,
          toggleDocumentsCallback: this.props.toggleDocumentsCallback,
          loadDocumentsAvailable: this.props.loadDocumentsAvailable,
          selectedComponent: this.state.selectedComponent,
          location: this.props.location,
          leftSelected: this.state.leftSelected,
          isConfirmAndSubmit: true,
          load: this.props.load,
          currentInvoice: this.state.carrierInvoice,
          onPageSelected: this.pageSelected,
          toggleDocumentData: this.toggleDocumentData,
          toggleMarkIllegibleData: this.toggleMarkIllegibleData,
          toggleHiddenData: this.toggleHiddenData,
          toggleDeliveryDocument: this.toggleDeliveryDocument,
          toggleShipmentDocument: this.toggleShipmentDocument,
          toggleCarrierDocument: this.toggleCarrierDocument,
          toggleCustomerLoadDocument: this.toggleCustomerLoadDocument,
          textToHighlight: this.state.textToHighlight,
          canEditDocumentType: !invoiceIsReadOnly(this.props),
          editDocumentType: this.editDocumentType,
          allowsEditing: this.props.allowsEditing,
          onContextMenu: this.openThumbnailLeft,
          expandBrowser: this.expandOrCompressBrowser,
          popoutReplacementChild: this.possibleLoadDetailInformation(),
          browserExpanded: this.state.browserExpanded,
          initialSelectedComponent: initialDocumentBrowserComponent(this.props),
          additionalComponents: additionalBrowserComponents(this.props),
          carrier: carrier(this.props),
          allowsEditingPodStatus: true,
          shipments: this.state.shipments,
          carrierInvoice: this.props.carrierInvoice,
          deliveryDocumentSelections: this.state.deliveryDocumentSelections,
          removeDeliveryDocumentSelectionsForDocument: this.removeDeliveryDocumentSelectionsForDocument,
          updateShipments: this.updateShipments,
          documentLoadRelationships: this.props.documentLoadRelationships
        }
      ) });
    });
    __publicField(this, "expandOrCompressBrowser", () => {
      this.setState({ browserExpanded: !this.state.browserExpanded });
    });
    __publicField(this, "updateCleanedSourceInvoiceNumber", () => {
      if (this.state.carrierInvoice) {
        const updatedInvoice = CarrierInvoicesStore.find(
          this.state.carrierInvoice.id
        );
        this.setState({
          cleanedSourceInvoiceNumber: updatedInvoice.cleaned_source_invoice_number
        });
      }
    });
    __publicField(this, "saveInvoice", (customerId) => {
      clearTimer(this.state);
      const promise = saveCarrierInvoice(this.state.carrierInvoice);
      promise.then(this.updateCleanedSourceInvoiceNumber);
      return promise;
    });
    __publicField(this, "forwardInvoiceDocumentsToTriumph", (invoice) => {
      this.setState({ forwardingDocuments: true });
      return Api.CarrierInvoices.forwardInvoiceDocumentsToTriumph(invoice.id).then(() => {
        this.setState({ forwardingDocuments: false, documentsForwarded: true });
      }).catch(() => this.setState({ forwardingDocuments: false }));
    });
    __publicField(this, "toggleDocumentData", (document, field) => {
      let settingPod = false;
      let newPodStatus;
      if (field === "includesPOD") {
        settingPod = true;
        newPodStatus = !document.is_pod;
        setPOD(document, newPodStatus);
        loadDocumentRelationshipService.forcePodDispositionForDocument(
          document.id,
          newPodStatus
        );
      } else {
        document.data[field] = !document.data[field];
      }
      this.forceUpdate();
      if (settingPod && !newPodStatus) {
        this.removeDeliveryDocumentSelectionsForDocument(document);
      }
      const extras = settingPod ? {
        load_state_id: this.props.load.id,
        page: "confirm_and_submit",
        pod_toggled: true
      } : void 0;
      Api.Documents.save(document, extras).then((data) => {
        this.updateShipments(data.tms_shipments);
      });
    });
    __publicField(this, "removeDeliveryDocumentSelectionsForDocument", (document) => {
      this.setState({
        deliveryDocumentSelections: this.state.deliveryDocumentSelections.filter(
          (entry) => entry.document_id !== document.id
        )
      });
    });
    __publicField(this, "toggleMarkIllegibleData", (document, page) => {
      page.illegible = !page.illegible;
      Api.DocumentPages.markIllegible(page).then((exceptionEvent) => {
        if (this.state.carrierInvoice) {
          const exceptionEvents = this.state.carrierInvoice.exception_events;
          const containsEvent = exceptionEvents.map((ee) => ee.id).includes(exceptionEvent.id);
          if (containsEvent) {
            this.state.carrierInvoice.exception_events = exceptionEvents.filter(
              (ee) => ee.id != exceptionEvent.id
            );
          } else {
            this.state.carrierInvoice.exception_events.push(exceptionEvent);
          }
          CarrierInvoicesStore.addOrUpdate(this.state.carrierInvoice);
        }
      });
      this.forceUpdate();
    });
    __publicField(this, "toggleHiddenData", (document, page) => {
      toggleHiddenDocument(document, page, () => {
        popout.refreshPopout();
        this.forceUpdate();
      });
    });
    __publicField(this, "toggleCarrierDocument", (document, carrierId) => {
      if (document.carrier_document_tms_carrier_id) {
        document.carrier_document_tms_carrier_id = null;
        Api.Documents.save(document);
        this.forceUpdate();
      } else {
        document.carrier_document_tms_carrier_id = carrierId;
        Api.Documents.setAsCarrierDocument(document, carrierId);
        this.forceUpdate();
      }
    });
    __publicField(this, "toggleDeliveryDocument", (entry) => {
      Api.Documents.setAssignedToDelivery(
        entry["document_id"],
        entry["tms_delivery_id"]
      );
      if (_.findWhere(this.state.deliveryDocumentSelections, entry)) {
        this.setState({
          deliveryDocumentSelections: _.reject(
            this.state.deliveryDocumentSelections,
            function(deliveryDocument) {
              return _.isEqual(entry, deliveryDocument);
            }
          )
        });
      } else {
        this.setState({
          deliveryDocumentSelections: [
            ...this.state.deliveryDocumentSelections,
            entry
          ]
        });
      }
    });
    __publicField(this, "toggleShipmentDocument", (tmsShipment, document) => {
      const isChecked = _.some(
        tmsShipment.shipment_documents,
        (shipmentDocument) => shipmentDocument.id === document.id
      );
      if (isChecked) {
        tmsShipment.shipment_documents = _.reject(
          tmsShipment.shipment_documents,
          function(shipmentDocument) {
            return shipmentDocument.id === document.id;
          }
        );
      } else {
        tmsShipment.shipment_documents.push({ id: document.id });
      }
      this.setState({ savingDocuments: true });
      Api.Documents.setAssignedToShipment(document, tmsShipment.id, !isChecked).then((data) => {
        this.updateShipments(data.tms_shipments);
        this.setState({ savingDocuments: false });
        for (var key in this.state.shipmentAssignmentListeners) {
          this.state.shipmentAssignmentListeners[key]();
        }
        if (this.props.carrierInvoice) {
          Api.CarrierInvoices.runRules(this.props.carrierInvoice.id);
        }
      }).catch(() => this.setState({ savingDocuments: false }));
    });
    __publicField(this, "toggleCustomerLoadDocument", (tmsCustomerLoad, document) => {
      const isChecked = _.some(
        tmsCustomerLoad.documents,
        (customerLoadDocument) => customerLoadDocument.id === document.id
      );
      if (isChecked) {
        tmsCustomerLoad.documents = _.reject(
          tmsCustomerLoad.documents,
          function(customerLoadDocument) {
            return customerLoadDocument.id === document.id;
          }
        );
      } else {
        tmsCustomerLoad.documents.push({ id: document.id });
      }
      this.setState({ savingDocuments: true });
      Api.Documents.setAssignedToCustomerLoad(
        document,
        tmsCustomerLoad.id,
        !isChecked
      ).then(() => this.setState({ savingDocuments: false })).catch(() => this.setState({ savingDocuments: false }));
    });
    __publicField(this, "noteFieldChanged", (note) => {
      this.setState({ note });
    });
    __publicField(this, "keyPressNotifier", (field) => {
      return (event) => {
        if (event.key === "Enter" && !isImeKey(event.nativeEvent)) {
          this.invoiceFieldChanged(field, event.target.value);
          this.saveInvoice();
        }
      };
    });
    __publicField(this, "invoiceFieldsChanged", (fields, values) => {
      const component = this;
      const invoice = Object.assign({}, this.state.carrierInvoice);
      _.each(fields, (field) => {
        if (field === "amount_to_pay" && component.state.editedPaymentFields.amount_to_pay) {
          return;
        } else {
          invoice[field] = values[_.indexOf(fields, field)];
        }
        this.setState({ carrierInvoice: invoice }, this.updateTimer);
        this.forceUpdate();
      });
    });
    __publicField(this, "invoiceFieldChanged", (field, value) => {
      const newState = {};
      newState.carrierInvoice = Object.assign({}, this.state.carrierInvoice);
      newState.carrierInvoice[field] = value;
      if (field === "source_invoice_number") {
        newState.cleanedSourceInvoiceNumber = value;
      }
      this.setState(newState, this.updateTimer);
      this.forceUpdate();
    });
    __publicField(this, "updateTimer", () => {
      clearTimer(this.state);
      this.setState({
        pendingTimeout: window.setTimeout(this.saveInvoice, 1800)
      });
    });
    __publicField(this, "pageSelected", () => {
      this.forceUpdate();
    });
    __publicField(this, "uiImprovementResolveLaterButton", () => {
      return /* @__PURE__ */ jsxs("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right", children: [
        /* @__PURE__ */ jsxs("span", { className: "load-detail__completion-context", children: [
          "Process ",
          this.props.completionContext
        ] }),
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "load-detail__button-cancel button--cancel",
            onClick: this.saveWithErrors,
            children: "Resolve Later"
          }
        ),
        this.savingButton()
      ] });
    });
    __publicField(this, "resolveLaterButton", () => {
      return this.uiImprovementResolveLaterButton();
    });
    __publicField(this, "auditBillingConfirmation", () => {
      return /* @__PURE__ */ jsx(
        AuditBillingConfirmation,
        {
          load: this.props.load,
          carrierInvoice: this.props.carrierInvoice,
          carrier: carrier(this.props),
          payment: this.payment(),
          messageOrException: this.state.messageOrException,
          handleSaveException: this.saveWithErrors,
          handleSendMessage: this.sendNow,
          handleApprove: this.saveAndMarkAsProcessed,
          handleMessageOrException: this.handleMessageOrException
        }
      );
    });
    __publicField(this, "handleMessageOrException", (e) => {
      this.setState({ messageOrException: e.target.value });
    });
    __publicField(this, "possibleAuditBillingOrSaveWithErrorsButton", () => {
      const isAbandoned = loadHelper.isAbandoned(this.props.carrierInvoice);
      const isInSavingState = this.state.savingException || this.state.savingDocuments;
      if (!isAbandoned && !invoiceIsReadOnly(this.props)) {
        if (this.auditBillingEnabled() && !isInSavingState) {
          return this.auditBillingConfirmation();
        } else if (isInSavingState && !isApprovable(this.props)) {
          return saveWithErrorButton();
        } else if (!isApprovable(this.props)) {
          return this.resolveLaterButton();
        }
      }
    });
    __publicField(this, "possibleUnIgnoreButton", () => {
      const isAbandoned = loadHelper.isAbandoned(this.props.carrierInvoice);
      const isMovedToTms = loadHelper.isMovedToTmsQueue(
        this.props.carrierInvoice
      );
      if (isAbandoned && !isMovedToTms) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: this.state.isUnIgnoring,
            className: "button--progress",
            onClick: this.revive,
            disabledText: "Un-Ignoring...",
            children: "Un-Ignore This Invoice"
          }
        );
      }
    });
    __publicField(this, "revive", () => {
      this.setState({ isUnIgnoring: true });
      Api.CarrierInvoices.revive(this.props.carrierInvoice.id).then(
        () => this.setState({ isUnIgnoring: false })
      );
    });
    __publicField(this, "savingButton", () => {
      return /* @__PURE__ */ jsx("button", { className: "button--caution", onClick: this.sendNow, children: "Save Exception and Send Now" });
    });
    __publicField(this, "sendNow", () => {
      this.setState({ savingException: true });
      this.saveInvoice().then((result) => {
        if (!result) {
          setTimeout(() => this.sendNow(), 100);
        } else if (result.error) {
          this.setState({ savingException: false });
        } else {
          this.markAsException(true);
        }
      });
    });
    __publicField(this, "saveWithErrors", () => {
      this.setState({ savingException: true });
      this.saveInvoice().then((result) => {
        if (!result) {
          setTimeout(() => this.saveWithErrors(), 100);
        } else if (result.error) {
          this.setState({ savingException: false });
        } else {
          this.markAsException(false);
        }
      });
    });
    __publicField(this, "markAsException", (shouldSendException) => {
      const carrierInvoice = this.props.carrierInvoice;
      Api.CarrierInvoices.markAsException(
        carrierInvoice.id,
        this.state.note,
        this.props.location.query.emailId,
        this.payment(),
        this.props.carrierInvoice.carrier_id
      ).then(() => {
        if (shouldSendException) {
          this.setState({ savingException: false, sendingException: true });
        } else {
          this.setState({ savingException: false });
          loadComplete(this.props);
        }
      }).catch(() => this.setState({ savingException: false }));
    });
    __publicField(this, "possiblePaymentInformation", () => {
      if (hasDocuments(this.props)) {
        return /* @__PURE__ */ jsx(
          PaymentInformation,
          {
            creatingLoad: creatingLoad(this.props),
            keyPressNotifier: this.keyPressNotifier,
            load: this.props.load,
            invoiceFieldChanged: this.invoiceFieldChanged,
            carrier: CarrierService.getCarrierOrUnknown(
              this.props.carrierInvoice.carrier_id
            ),
            canSaveAndMarkAsProcessed: isApprovable(this.props),
            saveAddress: (address) => saveAddress(this.props, address),
            savePaymentStrategy: (paymentStrategy, paymentDetails) => savePaymentStrategy(this.props, paymentStrategy, paymentDetails),
            readOnly: invoiceIsReadOnly(this.props),
            payment: this.payment(),
            onCarrierChanged: this.carrierChanged,
            invoiceChangeComplete: this.saveInvoice,
            updatePaymentField: this.updatePaymentField,
            carrierInvoice: this.props.carrierInvoice,
            canEditAddress: true,
            completionContext: this.props.completionContext,
            children: this.possibleForwardInvoiceDocumentsToTriumphButton()
          }
        );
      }
    });
    __publicField(this, "possibleSaveButtons", () => {
      const STATES = { NORMAL: 0, DISABLED: 1, SAVING: 2 };
      let state = void 0;
      if (this.state.missingRequiredFields === true) {
        state = STATES.DISABLED;
      } else if (isSaving(this.state)) {
        state = STATES.SAVING;
      } else if (this.state.missingRequiredFields === false) {
        state = STATES.NORMAL;
      }
      if (savableInvoice(this.props)) {
        switch (state) {
          case STATES.SAVING:
            return /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right", children: /* @__PURE__ */ jsxs("div", { className: "load-detail__save-buttons-container", children: [
              /* @__PURE__ */ jsxs("span", { className: "load-detail__completion-context", children: [
                "Process ",
                this.props.completionContext
              ] }),
              /* @__PURE__ */ jsx("div", { children: this.possibleSaveButton() })
            ] }) });
          case STATES.DISABLED:
            return /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right", children: /* @__PURE__ */ jsx("div", { className: "alert error", children: "Complete required fields to save or approve." }) });
          case STATES.NORMAL:
            if (this.auditBillingEnabled()) {
              return this.auditBillingConfirmation();
            } else {
              return /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-fixed load-detail__save-buttons-fixed--right", children: /* @__PURE__ */ jsxs("div", { className: "load-detail__save-buttons-container", children: [
                /* @__PURE__ */ jsxs("span", { className: "load-detail__completion-context", children: [
                  "Process ",
                  this.props.completionContext
                ] }),
                /* @__PURE__ */ jsx("div", { children: this.possibleSaveButton() }),
                /* @__PURE__ */ jsx("div", { className: "load-detail__save-buttons-join-text", children: joinText(this.props) }),
                /* @__PURE__ */ jsx("div", { children: this.possibleSaveAndApproveButton() })
              ] }) });
            }
        }
      }
    });
    __publicField(this, "possibleSaveButton", () => {
      if (isSavableFromPage(this.props) && (!indexAuditSplitAccount() || Auth._currentUser.auditor || Auth._currentUser.approver)) {
        return this.saveMarkProcessedAndApproveButton("Save");
      }
    });
    __publicField(this, "possibleSaveAndApproveButton", () => {
      if (isApprovableFromPage(this.props)) {
        return this.saveMarkProcessedAndApproveButton("Save and Approve", true);
      }
    });
    __publicField(this, "saveMarkProcessedAndApproveButton", (buttonText, approve) => {
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "load-detail__save-and-approve button--progress",
          disabled: isSaving(this.state),
          onClick: () => this.saveAndMarkAsProcessed(this.payment(), approve),
          disabledText: "Saving...",
          children: buttonText
        }
      ) });
    });
    __publicField(this, "forwardInvoiceDocumentsToTriumphButton", () => {
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          className: "button--forward",
          disabled: this.state.documentsForwarded || this.state.forwardingDocuments,
          disabledClassName: "button--forwarded",
          onClick: () => this.forwardInvoiceDocumentsToTriumph(this.state.carrierInvoice),
          disabledText: this.state.forwardingDocuments ? "Sending... " : "NOA Sent",
          children: "Send NOA"
        }
      ) });
    });
    __publicField(this, "possibleForwardInvoiceDocumentsToTriumphButton", () => {
      if (forwardInvoiceDocs(this.props)) {
        return this.forwardInvoiceDocumentsToTriumphButton();
      } else {
        return /* @__PURE__ */ jsx("div", {});
      }
    });
    __publicField(this, "saveAndMarkAsProcessed", (payment, approve) => {
      this.didStartSaving();
      clearTimer(this.state);
      Api.CarrierInvoices.markAsProcessed(
        this.props.carrierInvoice.id,
        payment,
        this.props.carrierInvoice.carrier_id,
        this.state.note,
        approve,
        this.state.carrierInvoice
      ).then(() => loadComplete(this.props)).catch(() => {
        if (this.mounted) {
          this.setState({
            immutable: this.state.immutable.set("isSaving", false)
          });
        }
      });
    });
    __publicField(this, "didStartSaving", () => {
      this.setState({
        immutable: this.state.immutable.set("isSaving", true)
      });
    });
    __publicField(this, "payment", () => {
      const result = {};
      const invoice = this.props.carrierInvoice;
      if (this.state.editedPaymentFields.amount_to_pay) {
        result.amount = this.state.payment.amount_to_pay;
      } else {
        result.amount = invoiceAmountToPay(this.props, invoice) || sourceInvoiceAmount(this.props, invoice);
      }
      if (this.canModifyPaymentDueOn) {
        if (this.state.editedPaymentFields.payOn) {
          result.payOn = this.state.payment.payOn;
        } else {
          result.payOn = invoice.date_to_pay || CarrierInvoiceHelper.paymentDueOn(this.state.carrierInvoice);
        }
      } else {
        result.payOn = null;
      }
      return result;
    });
    // payment() tests this without calling it, so hoisting it would disguise the missing
    // () as an intentional truthiness check. Move it once DEVEX-932 settles that bug.
    __publicField(this, "canModifyPaymentDueOn", () => {
      return Account.carrierInvoiceCanModifyPaymentDueOn();
    });
    __publicField(this, "updatePaymentField", (field, value) => {
      const e = this.state.editedPaymentFields;
      e[field] = true;
      const payment = this.state.payment;
      payment[field] = value;
      this.setState({ editedPaymentFields: e, payment });
      if (field == "payOn") {
        this.state.carrierInvoice.date_to_pay = value;
        saveCarrierInvoice(this.state.carrierInvoice);
      }
    });
    __publicField(this, "carrierChanged", (carrier2) => {
      if (carrier2) {
        this.invoiceFieldChanged("carrier_id", carrier2.id);
      }
    });
    __publicField(this, "changedCarrierPayable", (event) => {
      const ci = this.state.carrierInvoice;
      ci.tms_carrier_payable_id = parseInt(event.target.value) || null;
      this.setState({ carrierInvoice: ci });
      this.saveInvoice();
    });
    __publicField(this, "carrierPayable", () => {
      if (!Account.currentSettings().uses_carrier_payables) {
        return;
      }
      const carrierPayables = this.props.load.load.tms_carrier_payables || [];
      const lineItems = this.props.load.load.line_items || [];
      const currentCarrierPayableId = this.state.carrierInvoice.tms_carrier_payable_id;
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: "Linked Payable" }),
        /* @__PURE__ */ jsx(
          CarrierPayableChooser,
          {
            carrierPayables,
            carrierInvoice: this.props.carrierInvoice,
            lineItems,
            currentCarrierPayableId,
            carrier: carrier(this.props),
            allowsEditing: !invoiceIsReadOnly(this.props),
            onChange: this.changedCarrierPayable
          }
        )
      ] });
    });
    const labels = props.carrierInvoice ? props.carrierInvoice.labels : [];
    this.state = {
      note: null,
      payment: {},
      missingRequiredFields: void 0,
      shipmentAssignmentListeners: {},
      carrierInvoice: props.carrierInvoice,
      factoringCompany: null,
      cleanedSourceInvoiceNumber: (props.carrierInvoice || {}).cleaned_source_invoice_number,
      editedPaymentFields: {},
      isUnIgnoring: false,
      browserExpanded: false,
      shipments: {},
      immutable: Immutable.Map({
        isEditingLabels: false,
        isSaving: false,
        selectedLabels: selectionList.newList(labels)
      }),
      shipmentUpdate: {},
      messageOrException: "sendMessage",
      v3ReskinEnabled: props.v3ReskinEnabled,
      deliveryDocumentSelections: initialDeliveryDocuments(props)
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (shouldHardUpdateCarrierInvoice(state, props)) {
      return {
        carrierInvoice: props.carrierInvoice,
        cleanedSourceInvoiceNumber: props.carrierInvoice.cleaned_source_invoice_number
      };
    }
    return null;
  }
  componentDidMount() {
    var _a2;
    this.mounted = true;
    $(this.props.model).on(
      "document-browser-model:page-selected",
      this.pageSelected
    );
    if (((_a2 = this.props.model) == null ? void 0 : _a2.selectedPage) !== this.selectedPageAtFirstRender) {
      this.pageSelected();
    }
    if (this.props.carrierInvoice && _.isNull(this.props.carrierInvoice.amount_to_pay)) {
      this.props.carrierInvoice.amount_to_pay = this.props.carrierInvoice.source_invoice_amount;
      saveCarrierInvoice(this.props.carrierInvoice);
    }
    this.resetViewAfterAddingDocument(this.props);
    if (!creatingLoad(this.props)) {
      this.setMissingRequiredFields(false);
    }
    this.updateShipments(get.tmsShipments(this.props.load.load));
    if (this.props.carrierInvoice) {
      this.updateFactoringCompany(this.props.carrierInvoice);
    }
    popout.registerOnPopoutToggleListener(
      POPOUT_LISTENER_NAME,
      this.onPopoutToggle
    );
    maybePrefetchNextFlowModeItem(this.props.location);
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.resetViewAfterAddingDocument(this.props);
    }
    if (prevProps.model !== this.props.model) {
      $(this.props.model).on(
        "document-browser-model:page-selected",
        this.pageSelected
      );
      $(prevProps.model).off(
        "document-browser-model:page-selected",
        this.pageSelected
      );
    }
    if (prevProps.carrierInvoice !== this.props.carrierInvoice && this.props.carrierInvoice) {
      this.updateFactoringCompany(this.props.carrierInvoice);
    }
  }
  componentWillUnmount() {
    $(this.props.model).off(
      "document-browser-model:page-selected",
      this.pageSelected
    );
    popout.unregisterOnPopoutToggleListener(POPOUT_LISTENER_NAME);
    this.mounted = false;
  }
  render() {
    const invoice = this.props.carrierInvoice;
    const nextFlowModeItem = () => {
      console.log("Flow Mode: Debug move next");
      ToDashboardWithFilters(this.props.location);
    };
    const flowModeButton = Account.newFlowModeDebuggingEnabled() && isInNewFlowMode(this.props.location.query.onDone) ? /* @__PURE__ */ jsx("button", { onClick: nextFlowModeItem, children: "Next Flow Mode Item" }) : null;
    const legacyContents = /* @__PURE__ */ jsxs("div", { className: "document-container", children: [
      this.header(),
      possibleProgressBar(this.props),
      /* @__PURE__ */ jsxs("div", { className: "document-indexer__main-body load-detail__main", children: [
        this.leftModuleOrDocumentBrowser(invoice),
        this.documentBrowserOrMessage()
      ] }),
      /* @__PURE__ */ jsx("div", { id: "presence", children: /* @__PURE__ */ jsx(
        PresenceList,
        {
          location: this.props.location,
          batchId: batchIdFromURL(this.props),
          loadId: this.props.load.id
        }
      ) })
    ] });
    const contents = this.state.v3ReskinEnabled ? this.v3ReskinContents() : legacyContents;
    return /* @__PURE__ */ jsx(Blocker, { "data-component": "LoadDetail", modalView: this.possibleModalView(), children: /* @__PURE__ */ jsxs("div", { children: [
      flowModeButton,
      /* @__PURE__ */ jsx(
        DocumentTitle,
        {
          title: `Load ${this.props.load.load.load_id} -- Confirm and submit`,
          children: contents
        }
      )
    ] }) });
  }
}
export default LoadDetail;
